import { useQuery } from "react-query";
import { api } from "../../utils/api/api";

const getScholarshipApp = async (
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError
) => {
  try {
    const {
      data,
    } = await api.get(
      `${process.env.REACT_APP_API_URL}tracs_v3/scholarships/Scholarship_application_protected_api/getScholarshipApplicationMeta?scholarshipId=${scholarshipId}`,
      { token }
    );
    return data;
  } catch (err) {
    if (err?.httpStatus === 401) {
      handleInvalidToken();
    } else if (err?.httpStatus === 500) {
      handleAPIError();
    }
    throw new Error(err);
  }
};

export function useScholarshipAppOptions(
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError
) {
  return useQuery("scholarshipAppOptions", () =>
    getScholarshipApp(scholarshipId, token, handleInvalidToken, handleAPIError)
  );
}
